var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verified_Insrance",
    clipPath: "url(#clip0_1232_23925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.468 1.46374C8.16625 1.35063 7.83375 1.35063 7.532 1.46374L2.86533 3.21374C2.61113 3.30903 2.39207 3.47964 2.23744 3.70278C2.0828 3.92591 1.99997 4.19093 2 4.46241V8.03774C1.99998 9.15202 2.31025 10.2443 2.89605 11.1922C3.48184 12.14 4.32003 12.9061 5.31667 13.4044L7.55267 14.5224C7.69155 14.5919 7.84471 14.628 8 14.628C8.15529 14.628 8.30845 14.5919 8.44733 14.5224L10.6833 13.4044C11.68 12.9061 12.5182 12.14 13.104 11.1922C13.6898 10.2443 14 9.15202 14 8.03774V4.46241C14 4.19093 13.9172 3.92591 13.7626 3.70278C13.6079 3.47964 13.3889 3.30903 13.1347 3.21374L8.468 1.46374ZM11.1669 6.47534C11.1669 6.34932 11.1168 6.22845 11.0277 6.13932C10.9836 6.09515 10.9312 6.06011 10.8735 6.03621C10.8158 6.0123 10.754 6 10.6915 6C10.6291 6 10.5672 6.0123 10.5096 6.03621C10.4519 6.06011 10.3995 6.09515 10.3553 6.13932L7.10658 9.38838L5.6503 7.9321C5.60645 7.88671 5.55401 7.8505 5.49602 7.82559C5.43803 7.80068 5.37567 7.78757 5.31256 7.78702C5.24945 7.78647 5.18686 7.7985 5.12845 7.8224C5.07004 7.84629 5.01697 7.88158 4.97235 7.92621C4.92772 7.97084 4.89243 8.0239 4.86853 8.08231C4.84463 8.14073 4.83261 8.20331 4.83316 8.26642C4.83371 8.32953 4.84682 8.3919 4.87173 8.44988C4.89664 8.50787 4.93284 8.56032 4.97824 8.60416L6.74821 10.3738C6.79529 10.4209 6.85118 10.4583 6.9127 10.4837C6.97422 10.5092 7.04015 10.5223 7.10674 10.5223C7.17332 10.5223 7.23926 10.5092 7.30077 10.4837C7.36229 10.4583 7.41818 10.4209 7.46526 10.3738L11.0277 6.81137C11.1168 6.72224 11.1669 6.60137 11.1669 6.47534Z",
    fill: "#C5DEA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_23925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceVerified);
export default __webpack_public_path__ + "static/media/insurance-verified.cc9072e97ce93e9bdd1134fe5debc9c4.svg";
export { ForwardRef as ReactComponent };